export default __webpack_public_path__ + "static/media/funzo.e6929173.png";